module.exports = __webpack_public_path__ + "img/sunset-1.ae6b0678.jpg";